import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/userStore';

import AuthPage from '@/pages/auth.vue';
import LoginPage from '@/pages/login.vue';
import LogoutPage from '@/pages/logout.vue';
import MFAPage from '@/pages/mfa.vue';
import ApprovePage from '@/pages/approve.vue';
import RecoverypwdPage from '@/pages/recoverypwd.vue';
import ChangePwdPage from '@/pages/changepwd.vue';
import ResultPage from '@/pages/result.vue';
import HomePage from '@/pages/home.vue';
import AccountPage from '@/pages/account.vue';
import MembersPage from '@/pages/members.vue';
import InterventionsPage from '@/pages/interventions.vue';
import MemberPage from '@/pages/member.vue';
import InstallationCreate from '@/pages/installationCreate.vue';
import InstallationList from '@/pages/installationList.vue';
import InstallationEdit from '@/pages/installationEdit.vue';
import InstallationEditInformation from '@/pages/InstallationEditInformation.vue';
import InstallationEditComponents from '@/pages/installationEditComponents.vue';
import InstallationEditScenarios from '@/pages/installationEditScenarios.vue';
import InstallationEditAlerts from '@/pages/installationEditAlerts.vue';
import InstallationEditRooms from '@/pages/installationEditRooms.vue';

import ComponentEditHub from '@/pages/componentEditHub.vue';
import ComponentEditLink from '@/pages/componentEditLink.vue';
import ComponentEditReader from '@/pages/componentEditReader.vue';
import ComponentEditScenario from '@/pages/componentEditScenario.vue';
import ComponentEditExtension from '@/pages/componentEditExtension.vue';
import ComponentEditAjax from '@/pages/componentEditAjax.vue';
import ComponentEditSpc from '@/pages/componentEditSpc.vue';
import ComponentEditVideo from '@/pages/componentEditVideo.vue';
import ComponentEditSmartIntego from '@/pages/componentEditSmartIntego.vue';
import ComponentEditUz from '@/pages/componentEditUz.vue';
import ComponentEditAperio from '@/pages/componentEditAperio.vue';
import ComponentEditVideoDevice from '@/pages/componentEditVideoDevice.vue';
import NotFound from '@/pages/404.vue';
import AccountActivationSuccess from '@/pages/accountActivationSuccess.vue';
import LinkExpired from '@/pages/linkExpired.vue';
import AdminCreation from '@/pages/adminCreation.vue';
import AdminCreationSuccess from '@/pages/adminCreationSuccess.vue';
import AccountDeletionSuccess from '@/pages/accountDeletionSuccess.vue';
import AccountDeletionCanceled from '@/pages/accountDeletionCanceled.vue';
import AcceptInvitation from '@/pages/acceptInvitation.vue';
import InstallerValidation from '@/pages/installerValidation.vue';
import CGUInstallers from '@/pages/cguInstallers.vue';
import CGUManagers from '@/pages/cguManagers.vue';
import CGUUsers from '@/pages/cguUsers.vue';
import AppSetup from '@/pages/appSetup.vue';
import AppRedirect from '@/pages/appRedirect.vue';
import AppUser from '@/pages/appUser.vue';
import AppUserRedirect from '@/pages/appUserRedirect.vue';
import ConfirmAction from '@/pages/confirmAction.vue';

const routes = [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/auth',
    component: AuthPage,
    children: [
      {
        path: '/login',
        component: LoginPage
      },
      {
        path: '/mfa',
        component: MFAPage,
        meta: { requiresMFA: true },
      },
      {
        // Second step when the account is protected by the approval on a phone.
        path: '/approve',
        component: ApprovePage,
        meta: { requiresMFA: true },
      },
      {
        path: '/recoverypwd',
        component: RecoverypwdPage,
      },
      {
        path: '/changepwd',
        component: ChangePwdPage,
      },
      {
        path: '/result',
        component: ResultPage,
      },
      {
        path: '/logout',
        name: 'logout',
        component: LogoutPage,
        meta: { requiresAuth: true },
      },
    ]
  },
  {
    path: '/home',
    component: HomePage,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/account',
        component: AccountPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/installation-list',
        component: InstallationList,
        meta: { requiresAuth: true }
      },
      {
        path: '/members',
        component: MembersPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/interventions',
        component: InterventionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/member',
        component: MemberPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/installation-create',
        component: InstallationCreate,
        meta: { requiresAuth: true }
      },
      {
        path: '/installation-edit',
        component: InstallationEdit,
        meta: { requiresAuth: true },
        children: [
          {
            path: '/installation-edit-information',
            component: InstallationEditInformation,
            meta: { requiresAuth: true },
          },
          {
            path: '/installation-edit-components',
            component: InstallationEditComponents,
            meta: { requiresAuth: true },
          },
          {
            path: '/installation-edit-scenarios',
            component: InstallationEditScenarios,
            meta: { requiresAuth: true },
          },
          {
            path: '/installation-edit-alerts',
            component: InstallationEditAlerts,
            meta: { requiresAuth: true },
          },
          {
            path: '/installation-edit-rooms',
            component: InstallationEditRooms,
            meta: { requiresAuth: true },
          },

        ],
      },
      {
        path: '/component-edit-hub',
        component: ComponentEditHub,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-link',
        component: ComponentEditLink,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-reader',
        component: ComponentEditReader,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-scenario',
        component: ComponentEditScenario,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-extension',
        component: ComponentEditExtension,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-ajax',
        component: ComponentEditAjax,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-spc',
        component: ComponentEditSpc,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-video',
        component: ComponentEditVideo,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-smart-intego',
        component: ComponentEditSmartIntego,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-uz',
        component: ComponentEditUz,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-aperio',
        component: ComponentEditAperio,
        meta: { requiresAuth: true }
      },
      {
        path: '/component-edit-video-device',
        component: ComponentEditVideoDevice,
        meta: { requiresAuth: true }
      },
    ],
  },
  {
    path: '/account-activation-success',
    component: AccountActivationSuccess,
  },
  {
    path: '/link-expired',
    component: LinkExpired,
  },
  {
    path: '/admin-creation',
    component: AdminCreation,
  },
  {
    path: '/admin-creation-success',
    component: AdminCreationSuccess,
  },
  {
    path: '/account-deletion-success',
    component: AccountDeletionSuccess,
  },
  {
    path: '/account-deletion-canceled',
    component: AccountDeletionCanceled,
  },
  {
    path: '/accept-invitation',
    component: AcceptInvitation,
  },
  {
    path: '/installer-validation',
    component: InstallerValidation,
  },
  {
    path: '/cgu-installers',
    component: CGUInstallers,
  },
  {
    path: '/cgu-managers',
    component: CGUManagers,
  },
  {
    path: '/cgu-users',
    component: CGUUsers,
  },
  {
    path: '/app-setup',
    component: AppSetup,
  },
  {
    path: '/app-redirect',
    component: AppRedirect,
  },
  {
    path: '/app-user',
    component: AppUser,
  },
  {
    path: '/app-user-redirect',
    component: AppUserRedirect,
  },
  {
    path: '/action-confirm',
    component: ConfirmAction,
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  if (to.meta.requiresAuth && !userStore.installer) {
    next('/login');
  } else {
    if (to.meta.requiresMFA && !userStore.mfa_info) {
      next('/login');
    } else {
      next();
    }
  }
});

export default router